exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".share-table__feedbacks-graph{position:relative;margin:auto}", ""]);

